import urls from './urls';
import axios from 'axios';
import RestClient from './restClient';

class EditProfileApi {
  static getUserGallery(): Promise<any> {
    return axios
      .get(urls.GET_USER_PHOTO_GALLERY, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static getUserPhoto(params: any): Promise<any> {
    const queryString =
      (params &&
        Object.keys(params)
          .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
          .join('&')) ||
      null;
    const url = queryString ? `${urls.USER_PHOTO}${queryString ? '?' : ''}${queryString}` : urls.USER_PHOTO;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static patchUpdateUserPhoto(params: any): Promise<any> {
    const url = urls.USER_PHOTO;
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static makeUserMainPhoto(photoId: string | number): Promise<any> {
    const url = urls.MAKE_PHOTO_MAIN_PHOTO.replace('{photoId}', photoId.toString());
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static uploadUserPhoto(params: any): Promise<any> {
    const restClient = new RestClient();
    restClient.setBaseUrl(urls.BASE_RHPURL);
    // 7th arg is isMultipart
    return restClient.execute(urls.USER_PHOTO, 'POST', params, false, false, false, true)!.then((res: any) => res);
  }

  // Update user info
  static updateUserProfile(params: any): Promise<any> {
    const url = urls.USER_PROFILE;
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  // General info
  static getLookUpMaritalStatus(): Promise<any> {
    const url = urls.LOOK_UP_MARITAL_STATUS;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpSexual(): Promise<any> {
    const url = urls.LOOK_UP_SEXUAL;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpRace(): Promise<any> {
    const url = urls.LOOK_UP_RACE;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpPersonality(): Promise<any> {
    const url = urls.LOOK_UP_PERSONALITY;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpMyLooks(): Promise<any> {
    const url = urls.LOOK_UP_MY_LOOKS;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpBodyType(): Promise<any> {
    const url = urls.LOOK_UP_BODY_TYPE;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpHeightCm(): Promise<any> {
    const url = urls.LOOK_UP_HEIGHT;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpEyeColour(): Promise<any> {
    const url = urls.LOOK_UP_EYE_COLOUR;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpHairColour(): Promise<any> {
    const url = urls.LOOK_UP_HAIR_COLOUR;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpHairLength(): Promise<any> {
    const url = urls.LOOK_UP_HAIR_LENGTH;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpDrinking(): Promise<any> {
    const url = urls.LOOK_UP_DRINKING;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpSmoking(): Promise<any> {
    const url = urls.LOOK_UP_SMOKING;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  // Intimate Info
  static getLookUpSafeSex(): Promise<any> {
    const url = urls.LOOK_UP_SAFE_SEX;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpBodyHair(): Promise<any> {
    const url = urls.LOOK_UP_BODY_HAIR;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpPubicHair(): Promise<any> {
    const url = urls.LOOK_UP_PUBLIC_HAIR;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpEndowmentLength(): Promise<any> {
    const url = urls.LOOK_UP_ENDOWMENT_LENGTH;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpEndowmentThickness(): Promise<any> {
    const url = urls.LOOK_UP_ENDOWMENT_THICK_NESS;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpIntimatePiercing(): Promise<any> {
    const url = urls.LOOK_UP_INTIMATE_PIERCING;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpSexualPersonality(): Promise<any> {
    const url = urls.LOOK_UP_SEXUAL_PERSONALITY;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  // Interest
  static getLookUpSexualInterestSingle(_params?: any): Promise<any> {
    const url = urls.GET_SEXUAL_SINGLE_DATA;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpSexualInterestCouple(_params?: any): Promise<any> {
    const url = urls.GET_SEXUAL_COUPLE_DATA;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpGeneralInterest(): Promise<any> {
    const url = urls.LOOK_UP_GENERAL_INTEREST;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getLookUpFetishInterest(): Promise<any> {
    const url = urls.LOOK_UP_FETISH_INTEREST;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  // Profile builder
  static getProfileBuilderPersonality(): Promise<any> {
    const url = urls.LOOK_UP_PROFILE_BUILDER_PERSONALITY;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getProfileBuilderLooks(): Promise<any> {
    const url = urls.LOOK_UP_PROFILE_BUILDER_LOOKS;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getProfileBuilderInterest(): Promise<any> {
    const url = urls.LOOK_UP_PROFILE_BUILDER_INTEREST;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getProfileBuilderSeeking(): Promise<any> {
    const url = urls.LOOK_UP_PROFILE_BUILDER_SEEKING;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  // Participation
  static getLookUpParticipation(): Promise<any> {
    const url = urls.LOOK_UP_PARTICIPATION_LEVEL;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  // Intention
  static getLookUpIntention(): Promise<any> {
    const url = urls.LOOK_UP_INTENTION;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static getVerificationInfo(): Promise<any> {
    const url = urls.VERIFICATION_ACCOUNT;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static postVerificationInfo(params: any): Promise<any> {
    const restClient = new RestClient();
    restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.VERIFICATION_ACCOUNT;
    return restClient.execute(url, 'POST', params, false, false, false, true)!.then((res: any) => res);
  }

  static deleteRejetedPhotos(): Promise<any> {
    const url = urls.DELETE_ALL_REJECTED_PHOTOS;
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static getLookupDatas(): Promise<any> {
    const url = urls.LOOK_UP_EDIT_PROFILE;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static patchUserMemberType(params: any): Promise<any> {
    return axios
      .post(urls.PATCH_USER_MEMBER_TYPE, params, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  }

  static reorderUserImage = (params: any): Promise<any> => {
    return axios
      .post(urls.SORT_IMAGE_ORDER, params, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res);
  };
}

export default EditProfileApi;
